/**
 * The sewing patterns, by name. Admin only.
 */
import { NamedItemsPage } from '../named-items/NamedItemsPage';
import { sewingPatternService } from './api';

export function SewingPatternsPage() {
  return (
    <NamedItemsPage
      service={sewingPatternService}
      listLabel="Sewing patterns"
      initialName="BDP "
    />
  );
}
